import React from "react";
/* eslint-disable */
import {
    Box, Card, Grid, CardContent, Divider, CardHeader,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

    render() {
        const productData = this.props.productList;
        const searchQueryData = this.props.searchData;

        return (
            <div>
                <br />
                <br />
                <h3><center><u>Outlet Order Report</u></center></h3>
                <div>&nbsp;</div>
                <h4><center>Product name - {searchQueryData.productID.productName}</center></h4>
                <h4><center>Order date - {searchQueryData.date} </center></h4>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer style={{ marginLeft: '5px' }}>
                        <Table aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align={'left'}>Product Name</TableCell>
                                    <TableCell align={'left'}>Quantity</TableCell>
                                    <TableCell align={'left'}>Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {productData.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.factoryName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.quantity}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.orderDate.split('T')[0]}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
